<template>
  <div>
    <b-card v-if="loading">
      <template #header>
        <b-skeleton></b-skeleton>
      </template>
      <b-skeleton-img></b-skeleton-img>
      <br />
      <b-skeleton></b-skeleton>
      <b-skeleton width="85%"></b-skeleton>
      <b-skeleton width="55%"></b-skeleton>

      <template #footer>
        <b-skeleton type="button"></b-skeleton>
      </template>
    </b-card>
    <b-card v-if="!loading" class="text-center">
      <template #header>
        <span class="float-right">ID: {{ tokenId }}</span>
        <span class="float-left">
          <b-badge v-if="issues.current.length > 0 || issue != null" class="mr-2" variant="danger">Misconfigured</b-badge>
          <b-badge v-else-if="membership == false">Unlisted</b-badge>
          <b-badge
            v-else-if="membership == true"
            class="mr-2"
            variant="info"
            >For Sale</b-badge
          >
          <br />
        </span>
      </template>
      <b-img
        fluid
        :src="data ? data['image'] : require('@/assets/Brands/Blank.svg')"
      ></b-img>
      <div class="text-left">
        <hr />
        <!-- Missing Metadata -->
        <div v-if="issue == 'metadata' && !issues.metadata.supress">
          <b-alert show variant="danger"> Card is missing metadata </b-alert>
        </div>

        <!-- Under collateralized -->
        <div v-if="issue == 'balances' && !issues.balances.supress">
          <b-alert show variant="danger">
            Card is undercollateralized. <b>{{required}} DAI</b> more is required
          </b-alert>
        </div>
        <!-- Missing permissions -->
        <div v-if="permissions.loading == true">
          <b-skeleton></b-skeleton>
        </div>
        <div v-else-if="issue == 'permissions' && !issues.permissions.supress">
          <b-alert show variant="danger">
            The Marketplace does not have approval for the necessary permissions
          </b-alert>
        </div>

        <br />
        <!-- For sale -->
        <h1 class="inline">
          {{ balances ? balances.data.charge : "N/A" }} DAI Earned
        </h1>
        <span>Your Stake: {{ balances ? balances.data.base : "N/A" }} DAI</span
        ><br />
        <span
          >Asserted Card Value: {{ data ? data["balance"] : "N/A" }} USD</span
        >
      </div>
      <template #footer>
        <div class="text-left">
          <!-- Metadata Issues -->
          <div v-if="issue == 'metadata'">
            <b-button class="mr-2" variant="danger" @click="unstakeCard()"
              >Burn</b-button
            >
            <b-button
              class="mr-2"
              variant="outline-danger"
              @click="unstakeCard()"
              >Unstake</b-button
            >
          </div>
          <!-- Balance Issues -->
          <div v-if="issue == 'balances'">
            <b-button
              class="mr-2"
              v-if="required"
              variant="danger"
              @click="stake()"
              >Stake {{ required }} DAI</b-button
            >
            <b-button
              class="mr-2"
              variant="outline-danger"
              @click="unstakeCard()"
              >Unstake</b-button
            >
          </div>
          <!-- Permissions Issues -->
          <div v-if="issue == 'permissions'">
            <b-button class="mr-2" @click="setPermissions()"
              >Set Permissions</b-button
            >
            <b-button class="mr-2" @click="unstakeCard()">Unstake</b-button>
          </div>
          <!-- No Issues -->
          <div v-if="issues.current.length == 0 || issue == null">
            <b-button class="mr-2" variant="success" v-if="membership == false" @click="addMember()">Add to Marketplace</b-button>
            <b-button class="mr-2" @click="unstakeCard()">Unstake</b-button>
          </div>
        </div>
      </template>
    </b-card>
  </div>
</template>
<script>
export default {
  name: "Card",
  props: ["tokenId"],
  data() {
    return {
      loading: true,
      data: null,
      issues: {
        current: ["metadata", "balances", "permissions"],
        metadata: {
          supress: false,
        },
        balances: {
          supress: false,
        },
        permissions: {
          supress: false,
        },
      },
      permissions: {
        loading: true,
        data: null,
      },
      balances: {
        loading: true,
        data: {
          base: null,
          charge: null,
        },
      },
      membership: null,
    };
  },
  computed: {
    issue: function () {
      for (let i = 0; i < this.issues.current.length; i++) {
        let current = this.issues.current[i];
        if (current) {
          if (!this.issues[current]["supress"]) {
            return current;
          }
        }
      }
      return null;
    },
    required: function () {
      let claimed = this.data ? this.data["balance"] || 0 : 0;
      let current = this.balances.data["base"] ? this.balances.data["base"] : 0;
      let result = claimed * 2 - current;
      return result;
    },
  },
  watch: {
    "this.data": function (fresh, stale) {
      console.log("metadata");
      this.removeIssue("metadata");
    },
    "permissions.data": {
      deep: true,
      handler: function(fresh, stale) {
        console.log("permissions");
        if (fresh == true) {
          this.removeIssue("permissions");
        }
      },
    },
    required: {
      deep: true,
      handler: function (fresh, stale) {
        if (this.data) {
          if (fresh <= 0) {
            console.log("Token ID: " + this.tokenId + " Collateral: " + fresh)
            this.removeIssue("balances");
          }
        }
      },
    },
  },
  methods: {
    removeIssue(issue) {
      let i = this.issues.current.indexOf(issue);
      this.issues.current.splice(i > -1 ? i : 0, i > -1 ? 1 : 0);
    },
    getData() {
      this.loading = true;
      this.$store
        .dispatch("ethereum/getTokenData", this.tokenId)
        .then((ipfs) => {
          if (!ipfs) {
            throw new Error("No metadata");
          }
          let link = ipfs.indexOf("https://") > -1 ? ipfs : "https://" + ipfs + ".ipfs.dweb.link";
          fetch(link)
            .then((response) => response.json())
            .then((json) => {
              this.data = json;
              this.removeIssue("metadata");
            });
        })
        .catch((err) => {
          this.$bvToast.toast(err["message"] || err, {
            title: "Error",
            variant: "danger",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getBalances() {
      this.balances.loading = true;
      this.$store
        .dispatch("ethereum/getBalances", this.tokenId)
        .then((data) => {
          this.balances.data = data;
        })
        .catch((err) => {
          this.$bvToast.toast(err["message"] || err, {
            title: "Error",
            variant: "danger",
          });
        })
        .finally(() => {
          this.balances.loading = false;
        });
    },
    getPermissions() {
      this.permissions.loading = true;
      this.$store
        .dispatch("ethereum/getPermissions", {
          tokenId: this.tokenId,
        })
        .then((data) => {
          this.permissions.data = data;
        })
        .catch((err) => {
          this.$bvToast.toast(err["message"] || err, {
            title: "Error",
            variant: "danger",
          });
        })
        .finally(() => {
          this.permissions.loading = false;
        });
    },
    setPermissions() {
      debugger
      this.$store
        .dispatch("ethereum/setPermissions", {
          tokenId: this.tokenId,
        })
        .then((data) => {
          this.permissions.data = data;
        })
        .catch((err) => {
          this.$bvToast.toast(err["message"] || err, {
            title: "Error",
            variant: "danger",
          });
        })
        .finally(() => {
          this.permissions.loading = false;
        });
    },
    stake() {
      this.$store
        .dispatch("ethereum/stakeToken", {
          tokenId: this.tokenId,
          manager: "generic",
          assetToken: this.$store.state.ethereum.constants.token,
          assetAmount: this.required,
        })
        .then((n) => {
          console.log(JSON.stringify(n));
        })
        .catch((err) => {
          this.$bvToast.toast(err["message"] || err, {
            title: "Error",
            variant: "danger",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    unstakeCard() {
      this.$store
        .dispatch("ethereum/unstakeToken", {
          tokenId: this.tokenId,
          manager: "generic",
          assetToken: this.$store.state.ethereum.constants.token,
          assetAmount: this.required,
        })
        .then((n) => {
          console.log(JSON.stringify(n));
        })
        .catch((err) => {
          this.$bvToast.toast(err["message"] || err, {
            title: "Error",
            variant: "danger",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    isValidMember(){
      this.$store
      .dispatch("ethereum/isMember", {
        tokenId: this.tokenId,
      })
      .then((n) => {
        this.membership = Object.values(n)['0']
      })
      .catch((err) => {
        this.$bvToast.toast(err["message"] || err, {
          title: "Error",
          variant: "danger",
        });
      })
      .finally(() => {
        this.loading = false;
      });   
    },
    addMember(){
      this.$store
      .dispatch("ethereum/addMember", {
        tokenId: this.tokenId,
        assetAmount: this.data["balance"],
      })
      .then((n) => {
        console.log(JSON.stringify(n));
      })
      .catch((err) => {
        this.$bvToast.toast(err["message"] || err, {
          title: "Error",
          variant: "danger",
        });
      })
      .finally(() => {
        this.loading = false;
      });      
    }
  },
  mounted() {
    this.getData();
    this.getPermissions();
    this.getBalances();
    this.isValidMember();
  },
};
</script>